/* eslint-disable react-refresh/only-export-components */

import FrontofficeHome from 'pages/Frontoffice/FrontofficeHome'
import FrontofficeDescrizione from 'pages/Frontoffice/FrontofficeDescrizione'
import Verbale from 'pages/Frontoffice/Verbale/Verbale'
import RitornoPagamento from 'pages/Frontoffice/Verbale/RitornoPagamento'

import DatiConducenteHome from 'pages/DatiConducente/DatiConducenteHome'
import DatiConducenteVerbale from 'pages/DatiConducente/Verbale/Verbale'
import DatiCondicenteCompletamento from 'pages/DatiConducente/Verbale/Completamento'

import PassHome from 'pages/Pass/PassHome'
import PassDettagli from 'pages/Pass/PassDettagli/PassDettagli'
import PassLista from 'pages/Pass/PassLista/PassLista'

import CheckSsoCIE from 'components/CIE/CheckSsoCIE'
import AvvioSPID from 'components/SPID/AvvioSPID'
import RitornoSPID from 'components/SPID/RitornoSPID'
import HomeErrore from 'components/ui/HomeErrore'
import ArrivoTechnicalDesign from 'pages/ArrivoTechnicalDesign'
import { VerbaliProvider } from 'context/VerbaliProvider'
import { DatiConducenteProvider } from 'context/DatiConducenteProvider'
import Configurazioni from 'pages/Configurazioni'
import Home from 'pages/Home'
import Staff from 'pages/Staff'
import { ICONE } from '@lucan/base-ui'
import ConfigurazioniNuova from 'pages/ConfigurazioniNuova'
import LetturaDb from 'pages/LetturaDb/LetturaDb'

const CHIAVI_ROUTES = {
  FRONTOFFICE: 'frontoffice',
  FRONTOFFICE_DESCRIZIONE: 'frontofficeDescrizione',
  FRONTOFFICE_VERBALE: 'frontofficeVerbale',
  FRONTOFFICE_VERBALE_RITORNO_PAGAMENTO: 'frontofficeVerbaleRitornoPagamento',

  DATI_CONDUCENTE: 'datiConducente',
  DATI_CONDUCENTE_VERBALE: 'datiConducenteVerbale',
  DATI_CONDUCENTE_VERBALE_DECURTAZIONE: 'datiConducenteVerbaleDecurtazione',
  DATI_CONDUCENTE_VERBALE_COMPLETAMENTO: 'datiConducenteVerbaleCompletamento',

  PASS: 'pass',
  PASS_LISTA: 'passLista',
  PASS_DETTAGLI: 'passDettagli',

  AVVIO_SPID: 'avvioSPID',
  RITORNO_SPID: 'ritornoSPID',
  CIE_CHECKSSO:'cieCheckSso',
  ARRIVO_TECHNICAL_DESIGN: 'arrivoTechnicalDesign',
  HOME: 'home',
  HOME_ERRORE: 'homeErrore',

  CONFIGURAZIONI_NUOVA: 'configurazioni_nuova',
  READ_DB:'read_db',
  CONFIGURAZIONI: 'configurazioni',
  STAFF: 'staff',
}


const ROUTES_SENZA_COMANDO = [
  {
    pathRelativo: '/staff',
    chiave: CHIAVI_ROUTES.STAFF,
    label: 'Staff',
    Content: Staff,
    Icon: ICONE.STAFF,
    soloStaff: true,
    subRoutes: [{
      pathRelativo: '/configurazioni',
      chiave: CHIAVI_ROUTES.CONFIGURAZIONI,
      label: 'Configurazioni',
      Content: Configurazioni,
      Icon: ICONE.OPZIONI,
      soloStaff: true,
    },{
      pathRelativo: '/configurazioniNuova',
      chiave: CHIAVI_ROUTES.CONFIGURAZIONI_NUOVA,
      label: 'Nuova configurazione',
      Content: ConfigurazioniNuova,
      Icon: ICONE.OPZIONI,
      soloStaff: true,
    },{
      pathRelativo: '/read_db',
      chiave: CHIAVI_ROUTES.READ_DB,
      label: 'Lettura db',
      Content: LetturaDb,
      Icon: ICONE.CARTELLA,
      soloStaff: true,
    }]
  },
]

const ROUTES_NON_LOGGATO = [{

    pathRelativo: '/staff',
    chiave: CHIAVI_ROUTES.STAFF,
    label: 'Staff',
    Content: Staff,
    Icon: ICONE.STAFF,
  },
  {
    pathRelativo: '/avvioSPID/:idpurl',
    chiave: CHIAVI_ROUTES.AVVIO_SPID,
    label: 'Avvio SPID',
    Content: AvvioSPID,
  },
  {
    pathRelativo: '/cie/:intermediario/checkSso/:uuidAssertion',
    chiave: CHIAVI_ROUTES.CIE_CHECKSSO,
    label: 'Check Sso CIE',
    Content: CheckSsoCIE,
  },
  {
    pathRelativo: '/ritornoSPID/:esito',
    chiave: CHIAVI_ROUTES.RITORNO_SPID,
    label: 'Ritorno SPID',
    Content: RitornoSPID,
  },
  {
    pathRelativo: '/frontoffice',
    chiave: CHIAVI_ROUTES.FRONTOFFICE,
    label: 'Frontoffice',
    Content: FrontofficeHome,
    Provider: function VerbaliWrapper(props) {
      const { children } = props
      return <VerbaliProvider>{children}</VerbaliProvider>
    },
    subRoutes: [
      {
        pathRelativo: '/verbale/pagopareturn/:parametriEsitoPagamento/',
        chiave: CHIAVI_ROUTES.FRONTOFFICE_VERBALE_RITORNO_PAGAMENTO,
        label: 'Ritorno pagamento',
        Content: RitornoPagamento,
      },
      {
        pathRelativo: '/verbale/:tab',
        chiave: CHIAVI_ROUTES.FRONTOFFICE_VERBALE,
        label: 'Verbale',
        Content: Verbale,
      },
      {
        pathRelativo: '/descrizione',
        chiave: CHIAVI_ROUTES.FRONTOFFICE_DESCRIZIONE,
        label: 'Presa visione',
        Content: FrontofficeDescrizione,
      },
    ]
  },
  {
    pathRelativo: '/datiConducente',
    chiave: CHIAVI_ROUTES.DATI_CONDUCENTE,
    label: 'Dati conducente',
    Content: DatiConducenteHome,
    Provider: DatiConducenteProvider,
    subRoutes: [
      {
        pathRelativo: '/verbale/completamento/:modalitaInvio',
        chiave: CHIAVI_ROUTES.DATI_CONDUCENTE_VERBALE_COMPLETAMENTO,
        label: 'Completamento dati conducente',
        Content: DatiCondicenteCompletamento,
      },
      {
        pathRelativo: '/verbale/:tab',
        chiave: CHIAVI_ROUTES.DATI_CONDUCENTE_VERBALE,
        label: 'Verbale',
        Content: DatiConducenteVerbale,
        subRoutes: [
          {
            pathRelativo: '/:sottotab',
            chiave: CHIAVI_ROUTES.DATI_CONDUCENTE_VERBALE_DECURTAZIONE,
            label: 'Decurtazione punti',
            Content: DatiConducenteVerbale,
          },
        ]
      },
    ]
  },
  {
    pathRelativo: '/pass',
    chiave: CHIAVI_ROUTES.PASS,
    label: 'Pass',
    Content: PassHome,
    subRoutes: [
      {
        pathRelativo: '/lista',
        chiave: CHIAVI_ROUTES.PASS_LISTA,
        label: 'Lista permessi',
        Content: PassLista,
      },
      {
        pathRelativo: '/dettagli/:uuid',
        chiave: CHIAVI_ROUTES.PASS_DETTAGLI,
        label: 'Dettagli permesso',
        Content: PassDettagli,
      },
    ]
  },
  {
    pathRelativo: '/td/:servizio/:idPratica',
    chiave: CHIAVI_ROUTES.ARRIVO_TECHNICAL_DESIGN,
    label: 'Arrivo Technical Design',
    Content: ArrivoTechnicalDesign,
  },
  {
    pathRelativo: '/',
    chiave: CHIAVI_ROUTES.HOME,
    label: 'Home',
    Content: Home,
  }
]
const ASSETS = process.env.NODE_ENV === 'development'
  ? 'http://127.0.0.1:3021/'
  : '/ui/link/'

export {
  CHIAVI_ROUTES,
  ROUTES_SENZA_COMANDO,
  ROUTES_NON_LOGGATO,
  ASSETS
}